var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pricing px-0"},[_c('h1',{staticClass:"smfm-page-title mx-5",class:[
            _vm.$vuetify.breakpoint.smAndDown ? 'text-left' : 'text-center', 
            _vm.currentCurrCode !== 'EUR' ? 'mb-21' : ''
        ]},[_vm._v(" "+_vm._s(_vm.$t('app.pricing.pricing'))+" "),_c('about-pricing-dropdown')],1),_c('about-pricing-plans',{attrs:{"plans":_vm.plans,"features":_vm.features}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }